import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Panel,
  ProgressBar,
} from 'react-bootstrap';

import { FORM_ERROR } from 'final-form';
import { notify } from 'common/Notification';
import NetDocumentsCabinetProfileConfigAttributeForm from './NetDocumentsCabinetProfileConfigAttributeForm';

import request from 'superagent';
import _ from 'lodash';

class NetDocumentsCabinetProfileConfig extends Component {

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    cabinet: PropTypes.object.isRequired,
  };

  initialState = {
    isLoading: true,
    error: null,
    attributes: [],
    profile: null,
  };

  state = { ...this.initialState };

  componentDidMount() {
    this.fetchAttributesAndProfileConfig();
  }

  fetchAttributesAndProfileConfig(refreshFromNetdocs) {
    this.setState(this.initialState);

    console.log(`Requesting attribute list and profile settings for ${this.props.cabinet.id}`);
    Promise.all([
      // Attributes
      request
        .get(`/rpc/integrations/connections/${this.props.connectionId}/cabinets/${this.props.cabinet.id}/attributes`)
        .query({ refresh: refreshFromNetdocs })
        .then(res => this.setState({ attributes: res.body.attributes })),
      // Profile Config
      request
        .get(`/rpc/integrations/connections/${this.props.connectionId}/cabinets/${this.props.cabinet.id}/profile`)
        .then(res => this.setState({ profile: res.body.profile }))
        .catch(err => {
          console.log('Catching error refreshing profile', err);
          // make sure error is not in fetching, but just that cabinet profile hasn't been configured yet
          if (!_.get(err, 'response.body.error', '')
            .startsWith('No cabinet profile found for cabinet')) {
            throw new Error(err);
          }
        }),
    ])
      .then(
        res => this.setState({ isLoading: false }),
        errRes => {
          console.error('There was some error refreshing cabinet attributes and profile', errRes);
          this.setState({
            isLoading: false,
            error: errRes,
          });
        }
      );
    return true;
  };

  onSave = ({ attributes }) => {
    console.log('Saving ', attributes);
    const profile = attributes.map(({ id, value }) => ({ id, value })).filter( ({value}) => value );
    return request
      .post(`/rpc/integrations/connections/${this.props.connectionId}/cabinets/${this.props.cabinet.id}/profile`)
      .send({
        name: this.props.cabinet.name,
        profile,
      })
      .then(
        res => {
          console.log('Saved! Result:', res );
          notify.success('Cabinet Profile Saved');
          this.setState({ profile: res.body.profile });
        },
        errRes => {
          console.log('Error Saving!', errRes);
          return { [FORM_ERROR]: 'Error Saving'};
        }
      );
  }

  render() {
    const { cabinet } = this.props;

    const configurableAttrs = configurableAttributes(cabinet, this.state.attributes, this.state.profile);

    return (
      <Panel>
        <Panel.Heading>
          <Panel.Title componentClass="h3">
            <i className="fa fa-archive" /> {cabinet.name} ({cabinet.id})
          </Panel.Title>
        </Panel.Heading>

        <Panel.Body>{(() => {
            if (this.state.error) return (
              <Alert bsStyle="danger">
                There was an error loading Cabinet Information.
                If the problem persists, please quote the following when contacting CourtDrive support:
                <pre>{this.state.error}</pre>
              </Alert>
            );

            if (this.state.isLoading) return (
              <ProgressBar active now={100} />
            );

            return (
              <div>
                <Alert bsStyle="info">
                  <strong>
                  {
                    organizingAttributes(cabinet, this.state.attributes)
                      .map(attr => attr.name)
                      .join(" > ")
                  }
                  </strong>
                  { ' ' }
                  needs to be assigned to each CaseFolder that should be synced.
                  Attributes below will be applied to each uploaded file.
                </Alert>

                <NetDocumentsCabinetProfileConfigAttributeForm
                  connectionId={this.props.connectionId}
                  cabinet={cabinet}
                  attributes={ configurableAttrs }
                  cabinetAttributes={ this.state.attributes }
                  onSave={ this.onSave }
                  />

              </div>
            );
          })()}
        </Panel.Body>

        <Panel.Footer>
          <Button bsStyle="link" bsSize="xsmall" onClick={() => this.fetchAttributesAndProfileConfig(true) }>Refresh Attributes</Button>
        </Panel.Footer>
      </Panel>
    );
  }
}

function organizingAttributes(cabinet, attributes) {
  if (!cabinet.wsAttrNum) {
    console.log('Cabinet is not organized in a workspace');
    return [];
  }
  const attributesById = _.keyBy(attributes, attr => attr.id);

  const organizingAttribute = attributesById[cabinet.wsAttrNum];

  if (!organizingAttribute) {
    console.log(`Can not find organizing attribute - no attribute with id '${cabinet.wsAttrNum}' found in`, attributes)
    return [];
  }

  const attributeList = [organizingAttribute];
  let attr = organizingAttribute;
  while (attr.linked) {
    attr = attributesById[attr.linked];
    attributeList.unshift(attr);
  }

  return attributeList;
}

function configurableAttributes(cabinet, attributes, profile) {
  const attributeIdsToExclude = _.map(
    organizingAttributes(cabinet, attributes),
    attr => attr.id
  );
  const attributeValuesById = _.mapValues(_.keyBy(profile, 'id' ), 'value');
  return attributes
    // organizing attributes are not globally configurable
    .filter( attr => ! attributeIdsToExclude.includes(attr.id) )
    // merge any configured profile fields values
    .map( attr => ({ ... attr, value: attributeValuesById[attr.id] }) );
}

export default NetDocumentsCabinetProfileConfig;



// WEBPACK FOOTER //
// ./src/Integrations/connections/NetDocumentsCabinetProfileConfig.jsx